/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type CalculationRuleRequestAwardLogic =
  (typeof CalculationRuleRequestAwardLogic)[keyof typeof CalculationRuleRequestAwardLogic];

export const CalculationRuleRequestAwardLogic = {
  STACK_CAPPED: 'STACK_CAPPED',
  STACK_UNCAPPED: 'STACK_UNCAPPED',
  MEETING_NEED: 'MEETING_NEED',
  REPLACING_MERIT: 'REPLACING_MERIT',
  TOTAL_GIFT_AID: 'TOTAL_GIFT_AID',
} as const;
